export const EPLEDGE_UNPLEDGE = "EPLEDGE_UNPLEDGE";
export const EPLEDGE_UNPLEDGE_ERROR = "EPLEDGE_UNPLEDGE_ERROR";
export const EPLEDGE_UNPLEDGE_HIDE_ERROR = "EPLEDGE_UNPLEDGE_HIDE_ERROR";
export const EPLEDGE_UNPLEDGE_START_LOADER = "EPLEDGE_UNPLEDGE_START_LOADER";
export const EPLEDGE_UNPLEDGE_STOP_LOADER = "EPLEDGE_UNPLEDGE_STOP_LOADER";
